angular.module('admin.gallery.index', [
    'security.authorization',
    'config',
    'services.utility',
    'resources.AdminGroup',
    'resources.AdminUser',
    'services.adminResource',
    'services.search',
    'filters.timeAgo',
    'services.algoliaResource',
    'directives.croppic',
    'resources.Album',
    'resources.Image',
    'ngFileUpload',
    'angular-growl',
    'services.localizedMessages'
  ])
  
  .config(["$stateProvider", function($stateProvider) {
    $stateProvider
      .state('admin.gallery', {
        url: '/gallery',
        title: 'Manage gallery',
        views: {
          'main@': {
            template: require('./admin-gallery.tpl.html'),
            controller: 'GalleryIndexCtrl',
            resolve: {
              groups: ["AdminGroup", function (AdminGroup) {
                return AdminGroup.query().$promise;
              }]
            }
          }
        },
        resolve: {
          initSearch: ["searchService", "AdminUser", function (searchService, AdminUser) {
            searchService.setSearchFn(AdminUser.search);
            searchService.setRedirectBase('/admin/gallery/edit');
          }]
        }
      });
  }])
  
  .controller('GalleryIndexCtrl',
    ["$scope", "$route", "APP_IMG_URLS", "$location", "$log", "utility", "Upload", "growl", "Album", "adminResource", "AdminUser", "algoliaResource", "searchService", "groups", "localizedMessages", function($scope, $route, APP_IMG_URLS, $location, $log, utility, Upload, growl, Album, adminResource, AdminUser, algoliaResource, searchService, groups, localizedMessages) {
      $scope.localizedMessages = localizedMessages;
      $scope.album = { title: "", description: "" };
			$scope.image = { title: "", description: "" };
			$scope.imgUrl = APP_IMG_URLS['base'];
      $scope.file = {};
      $scope.fileType = "";
      
      var slugify = require('../../utils/slugify');

      $scope.search = searchService.search;
      $scope.groups = groups.data;
      $scope.images = [];
      $scope.albums = [];

      $scope.deleteImage = function (data) {
        var obj = $scope;
        if (confirm("Chcesz usunąć obraz?")) {
          adminResource.deleteImage(data._id).then((result) => {
            growl.info('Image Deleted!');
            fetchData()
          })
        }
      }
      $scope.deleteAlbum = function (data) {
        console.log(data)
        var obj = $scope;
        if (confirm("Czy chcesz usunąć album i wszystkie jego obrazy?")) {
          adminResource.deleteAlbum(data._id).then((result) => {
            growl.info('Album Deleted!');
            fetchData()
          })
        }
      }

      $scope.submitAlbum = function ($event) {
        var obj = $scope;
        if ($scope.album && $scope.album.image){
          $scope.album.file = $scope.album.image;
        }
        if ($scope.album._id){
          adminResource.editAlbum($scope.album).then((result) => {
            growl.info('Album Updated!');
            console.log("r:", result)
            obj.album = {};
            $scope.a_file={};
            setTimeout(() => location.reload(), 2000);
          })
        } else {
          const newObj = Object.assign($scope.album, {
            slug: slugify($scope.album.title.replace(/<.+?>/g,"").replace(/  /g," "))
          })
          adminResource.addAlbum(newObj).then((result) => {
            growl.info('Album Created!');
            console.log("r:", result)
            obj.album = {};
            $scope.a_file={};
            setTimeout(() => location.reload(), 2000);
          })
        }
      };
      $scope.submitImage = function ($event) {
        var obj = $scope;
        if ($scope.image && $scope.image.image){
          $scope.image.file = $scope.image.image;
        }
        if ($scope.image._id){
          adminResource.editImage($scope.image).then((result) => {
            growl.info('Image Updated!');
            obj.image = {};
            $scope.file={};
            setTimeout(() => location.reload(), 2000);
          })
        } else {
          if(!$scope.file || !$scope.file.name || !$scope.image.title || !$scope.image.description || !$scope.image.album_id){
            growl.error('Invalid data!');
            return;
          }
          const newObj = Object.assign($scope.image, {
            slug: slugify($scope.album.title.replace(/<.+?>/g,"").replace(/  /g," "))
          })
          adminResource.addImage(newObj).then((result) => {
            growl.info('Image Created!');
            console.log("r:", result)
            $scope.file={};
            obj.image = {};
            //fetchData();
            setTimeout(() => location.reload(), 2000);
          })
        }
      };
      
      var fetchData = function () {
        $scope.a_uploading = false;
        $scope.a_thumbnail = "";
        $scope.uploading = false;
        $scope.thumbnail = "";
        $scope.album.image = "";
        $scope.image.image = "";
        adminResource.getAlbums().then(function(data) {
          $scope.albums = data;

          adminResource.getImages().then(function(data2) {
            $scope.images = data2;
            $scope.images.map(img =>{
              var album = $scope.albums.filter(obj => img.album_id == obj._id)[0];
              img.album = album;
              return img;
            })
            //update url in browser addr bar
            //$location.search($scope.query);
          }, function(e) {
            $log.error(e);
          });
          //update url in browser addr bar
          $location.search($scope.query);
        }, function(e) {
          $log.error(e);
        });
        
      };
  
      $scope.$watchCollection('query', function(newState, oldState) {
        if ( angular.equals(newState, oldState) ) {
          return;
        }
        fetchData();
      });
  
      $scope.sorts = [
        {label: "id \u25B2", value: "_uid"},
        {label: "id \u25BC", value: "-_uid"},
        {label: "username \u25B2", value: "username"},
        {label: "username \u25BC", value: "-username"},
        {label: "email \u25B2", value: "email"},
        {label: "email \u25BC", value: "-email"}
      ];
      $scope.limits = [
        {label: "10 Materiałów", value: 10},
        {label: "20 Materiałów", value: 20},
        {label: "50 Materiałów", value: 50},
        {label: "100 Materiałów", value: 100}
      ];
  
      $scope.query = $location.search();
      $scope.query.limit = $scope.query.limit || 10;
      $scope.query.is_active = '';
      $scope.query.group = '';
      $scope.query.author = '';
  
      fetchData();
  
      $scope.selectUpload = function (type) {
        $scope.fileType = type;
      }
      $scope.$watch('file', function (file) {
        $scope.upload(file);
      });
      $scope.$watch('a_file', function (file) {
        $scope.a_upload(file);
      });
			
      $scope.upload = function (file) {
        console.log("upload")
				if (!file.name) return;
        $scope.uploading = true;
				$scope.thumbnail = file;
        Upload.upload({
          url: '/api/articles/upload',
          data: {file}
        }).then(function (resp) {
          $scope.uploading = false;
					$scope.thumbnail = APP_IMG_URLS.base + resp.data.filename;
          $scope.image.image = resp.data.filename;
        }, function (resp) {
          $scope.uploading = false;
          $scope.thumbnail = null;
          console.log('Error status: ' + resp.status);
        }, function (evt) {
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        });
      };

      $scope.a_upload = function (file) {
				if (!file.name) return;
        $scope.a_uploading = true;
				$scope.a_thumbnail = file;
        Upload.upload({
          url: '/api/articles/upload',
          data: {file}
        }).then(function (resp) {
          $scope.a_uploading = false;
					$scope.a_thumbnail = APP_IMG_URLS.base + resp.data.filename;
          $scope.album.image = resp.data.filename;
        }, function (resp) {
          $scope.a_uploading = false;
          $scope.a_thumbnail = null;
          console.log('Error status: ' + resp.status);
        }, function (evt) {
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        });
      };

      $scope.editImage = function(img){
        img.date = new Date(img.date);
        $scope.image = angular.copy(img);
      }
      $scope.editAlbum = function(album){
        $scope.album = angular.copy(album);
      }
  
}]);
  
    


// WEBPACK FOOTER //
// ./client/src/app/admin/gallery/admin-gallery.js